import { queryParams, type RouteQueryOptions, type RouteDefinition, type RouteFormDefinition, applyUrlDefaults } from './../../../../wayfinder'
/**
* @see \App\Http\Controllers\Admin\Bookings\BookingPaymentController::refund
* @see app/Http/Controllers/Admin/Bookings/BookingPaymentController.php:743
* @route '/bookings/{booking}/payments/{payment}/refund'
*/
export const refund = (args: { booking: string | number, payment: string | number } | [booking: string | number, payment: string | number ], options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: refund.url(args, options),
    method: 'post',
})

refund.definition = {
    methods: ["post"],
    url: '/bookings/{booking}/payments/{payment}/refund',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\Admin\Bookings\BookingPaymentController::refund
* @see app/Http/Controllers/Admin/Bookings/BookingPaymentController.php:743
* @route '/bookings/{booking}/payments/{payment}/refund'
*/
refund.url = (args: { booking: string | number, payment: string | number } | [booking: string | number, payment: string | number ], options?: RouteQueryOptions) => {
    if (Array.isArray(args)) {
        args = {
            booking: args[0],
            payment: args[1],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        booking: args.booking,
        payment: args.payment,
    }

    return refund.definition.url
            .replace('{booking}', parsedArgs.booking.toString())
            .replace('{payment}', parsedArgs.payment.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Admin\Bookings\BookingPaymentController::refund
* @see app/Http/Controllers/Admin/Bookings/BookingPaymentController.php:743
* @route '/bookings/{booking}/payments/{payment}/refund'
*/
refund.post = (args: { booking: string | number, payment: string | number } | [booking: string | number, payment: string | number ], options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: refund.url(args, options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Admin\Bookings\BookingPaymentController::refund
* @see app/Http/Controllers/Admin/Bookings/BookingPaymentController.php:743
* @route '/bookings/{booking}/payments/{payment}/refund'
*/
const refundForm = (args: { booking: string | number, payment: string | number } | [booking: string | number, payment: string | number ], options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: refund.url(args, options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Admin\Bookings\BookingPaymentController::refund
* @see app/Http/Controllers/Admin/Bookings/BookingPaymentController.php:743
* @route '/bookings/{booking}/payments/{payment}/refund'
*/
refundForm.post = (args: { booking: string | number, payment: string | number } | [booking: string | number, payment: string | number ], options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: refund.url(args, options),
    method: 'post',
})

refund.form = refundForm

/**
* @see \App\Http\Controllers\Admin\Bookings\BookingPaymentController::datetime
* @see app/Http/Controllers/Admin/Bookings/BookingPaymentController.php:1354
* @route '/bookings/{booking}/payments/{payment}/datetime'
*/
export const datetime = (args: { booking: string | number, payment: string | number } | [booking: string | number, payment: string | number ], options?: RouteQueryOptions): RouteDefinition<'put'> => ({
    url: datetime.url(args, options),
    method: 'put',
})

datetime.definition = {
    methods: ["put"],
    url: '/bookings/{booking}/payments/{payment}/datetime',
} satisfies RouteDefinition<["put"]>

/**
* @see \App\Http\Controllers\Admin\Bookings\BookingPaymentController::datetime
* @see app/Http/Controllers/Admin/Bookings/BookingPaymentController.php:1354
* @route '/bookings/{booking}/payments/{payment}/datetime'
*/
datetime.url = (args: { booking: string | number, payment: string | number } | [booking: string | number, payment: string | number ], options?: RouteQueryOptions) => {
    if (Array.isArray(args)) {
        args = {
            booking: args[0],
            payment: args[1],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        booking: args.booking,
        payment: args.payment,
    }

    return datetime.definition.url
            .replace('{booking}', parsedArgs.booking.toString())
            .replace('{payment}', parsedArgs.payment.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Admin\Bookings\BookingPaymentController::datetime
* @see app/Http/Controllers/Admin/Bookings/BookingPaymentController.php:1354
* @route '/bookings/{booking}/payments/{payment}/datetime'
*/
datetime.put = (args: { booking: string | number, payment: string | number } | [booking: string | number, payment: string | number ], options?: RouteQueryOptions): RouteDefinition<'put'> => ({
    url: datetime.url(args, options),
    method: 'put',
})

/**
* @see \App\Http\Controllers\Admin\Bookings\BookingPaymentController::datetime
* @see app/Http/Controllers/Admin/Bookings/BookingPaymentController.php:1354
* @route '/bookings/{booking}/payments/{payment}/datetime'
*/
const datetimeForm = (args: { booking: string | number, payment: string | number } | [booking: string | number, payment: string | number ], options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: datetime.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'PUT',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Admin\Bookings\BookingPaymentController::datetime
* @see app/Http/Controllers/Admin/Bookings/BookingPaymentController.php:1354
* @route '/bookings/{booking}/payments/{payment}/datetime'
*/
datetimeForm.put = (args: { booking: string | number, payment: string | number } | [booking: string | number, payment: string | number ], options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: datetime.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'PUT',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'post',
})

datetime.form = datetimeForm

/**
* @see \App\Http\Controllers\Admin\Bookings\BookingPaymentController::method
* @see app/Http/Controllers/Admin/Bookings/BookingPaymentController.php:1418
* @route '/bookings/{booking}/payments/{payment}/method'
*/
export const method = (args: { booking: string | number, payment: string | number } | [booking: string | number, payment: string | number ], options?: RouteQueryOptions): RouteDefinition<'patch'> => ({
    url: method.url(args, options),
    method: 'patch',
})

method.definition = {
    methods: ["patch"],
    url: '/bookings/{booking}/payments/{payment}/method',
} satisfies RouteDefinition<["patch"]>

/**
* @see \App\Http\Controllers\Admin\Bookings\BookingPaymentController::method
* @see app/Http/Controllers/Admin/Bookings/BookingPaymentController.php:1418
* @route '/bookings/{booking}/payments/{payment}/method'
*/
method.url = (args: { booking: string | number, payment: string | number } | [booking: string | number, payment: string | number ], options?: RouteQueryOptions) => {
    if (Array.isArray(args)) {
        args = {
            booking: args[0],
            payment: args[1],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        booking: args.booking,
        payment: args.payment,
    }

    return method.definition.url
            .replace('{booking}', parsedArgs.booking.toString())
            .replace('{payment}', parsedArgs.payment.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Admin\Bookings\BookingPaymentController::method
* @see app/Http/Controllers/Admin/Bookings/BookingPaymentController.php:1418
* @route '/bookings/{booking}/payments/{payment}/method'
*/
method.patch = (args: { booking: string | number, payment: string | number } | [booking: string | number, payment: string | number ], options?: RouteQueryOptions): RouteDefinition<'patch'> => ({
    url: method.url(args, options),
    method: 'patch',
})

/**
* @see \App\Http\Controllers\Admin\Bookings\BookingPaymentController::method
* @see app/Http/Controllers/Admin/Bookings/BookingPaymentController.php:1418
* @route '/bookings/{booking}/payments/{payment}/method'
*/
const methodForm = (args: { booking: string | number, payment: string | number } | [booking: string | number, payment: string | number ], options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: method.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'PATCH',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Admin\Bookings\BookingPaymentController::method
* @see app/Http/Controllers/Admin/Bookings/BookingPaymentController.php:1418
* @route '/bookings/{booking}/payments/{payment}/method'
*/
methodForm.patch = (args: { booking: string | number, payment: string | number } | [booking: string | number, payment: string | number ], options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: method.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'PATCH',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'post',
})

method.form = methodForm

const payments = {
    refund: Object.assign(refund, refund),
    datetime: Object.assign(datetime, datetime),
    method: Object.assign(method, method),
}

export default payments